import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import {Link} from "react-router-dom";
import Form from "react-bootstrap/Form";
import ic_cross from "../assets/images/ic_cross.svg";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import ApiConfig from "../api/ApiConfig";
import {
    DeleteCallWithErrorResponse, getWithAuthCallWithErrorResponse, multipartPostCallWithErrorResponse, simpleGetCall,
} from "../api/ApiServices";
import Loading from "../sharedComponents/Loaders/Loading";
import {Table} from "react-bootstrap";
import swal from "sweetalert";
import {PaginationCustomer} from "./PaginationCustomer";
import DragAndDropImages from "../sharedComponents/DragandDropImages";
import DragAndDropSingleFile from "../sharedComponents/DragAndDropSingleFile";
import ic_order from "../assets/images/ic_order.svg";
import ic_product from "../assets/images/ic_product.svg";

const Products = () => {
    const {sidebar, setCount, count} = useContext(AppContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [numPages, setNumPages] = useState(1);
    const changePage = (page) => {
        if (page > 0 && page <= numPages) {
            setCurrentPage(page);
        }
    };

    // Search func()ty state
    const [searchInput, setSearchInput] = useState("");

    const handleSearchInputChange = (e) => {
        setSearchInput(e.target.value);
    };

    const [addDetails, setaddDetails] = useState([]);
    useEffect(() => {
        $(document).ready(function () {
            let table;
            if ($.fn.dataTable.isDataTable("#table_id")) {
                table = $("#table_id").DataTable();
            } else {
                table = $("#table_id").DataTable({
                    ordering: false,

                    language: {
                        search: "", searchPlaceholder: "Search...", sLengthMenu: "Entries per page _MENU_",
                    },
                });
            }
        });
    }, []);

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => {
        setSelectedProdId(0);
        setAddProductData({
            id: "",
            CategoryId: "",
            Name: "",
            Currency: "",
            Price: "",
            Description: "",
            Brand_img: [],
            Supp_img: [],
            Ingredients: "",
            productDetails: {},
            Images: [],
            recommendedProductIds: "",
        });
        setaddDetails([]);
        setShow(true);
    };
    const handleEditShow = (id) => {
        setShow(true);
        setSelectedProdId(id);
    };

    const [deleteShow, setDeleteShow] = useState(false);
    const handleDeleteClose = () => {
        setDeleteShow(false);
    };
    const handleDeleteShow = (id) => {
        setDeleteShow(true);
        setSelectedProdId(id);
    };

    const [viewShow, setViewShow] = useState(false);
    const handleViewClose = () => {
        setViewShow(false);
    };
    const handleViewShow = (productId) => {
        setViewShow(true);
        setSelectedProdId(productId);
    };
    const [viewData, setViewData] = useState({});
    const [validated, setValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [productsList, setProductsList] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedPage, setSelectedPage] = useState("1");
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [selectedProdId, setSelectedProdId] = useState(0);
    const [productDetails, setProductDetails] = useState("");

    const [addProductData, setAddProductData] = useState({
        id: "",
        CategoryId: "",
        Name: "",
        Currency: "",
        Price: "",
        Description: "",
        Brand_img: [],
        Supp_img: [],
        Ingredients: "",
        productDetails: [],
        Images: [],
        recommendedProductIds: "",
    });

    console.log("productDetails", productDetails);

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            addProduct(event);
        }

        setValidated(true);
    };

    const getProductDetails = () => {
        simpleGetCall(`${ApiConfig.VIEW_SINGLE_PRODUCT_ID + "/" + selectedProdId}`)
            .then((res) => {
                let data = res;
                let productDetails = data?.details;
                let detailsMap = productDetails?.map((detail, index) => {
                    console.log(detail)
                    return {
                        id: index, inputValue: detail,
                    }
                });
                setaddDetails(detailsMap)
                setViewData(data);
                if (selectedProdId) {
                    setAddProductData({
                        id: data?.id,
                        CategoryId: data?.categoryId,
                        Name: data?.name,
                        Price: data?.price,
                        Description: data?.discription,
                        Currency: data?.currency,
                        Images: data?.images,
                        Brand_img: data?.brand_img ? [{img: data.brand_img}] : [],
                        Supp_img: data?.supp_img ? [{img: data.supp_img}] : [],
                        Ingredients: data?.ingredients,
                        recommendedProductIds: data?.recommendedProductIds,
                    });
                }
            })
            .catch((err) => {
                console.log("GET single id error", err);
            });
    };

    const getProductsList = (page = 1) => {
        setIsLoading(true);
        getWithAuthCallWithErrorResponse(ApiConfig.PRODUCTS + `${page}&category_id=${selectedCategoryId || ""}&size=${perPage}`)
            .then((res) => {
                let data = res.json;
                if (data) {
                    setProductsList(data.list || []);
                    setPerPage(data.per_page || 15);
                    setNumPages(data.num_pages || 1);
                    setCurrentPage(data.current_page || 1);
                    setIsLoading(false);
                }
            })

            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };

    const getCategories = () => {
        setIsLoading(true);
        getWithAuthCallWithErrorResponse(ApiConfig.CATEGORIES)
            .then((res) => {
                let data = res.json;
                if (data) {
                    setCategories(data.list);
                    setSelectedCategoryId(data.list[0]?.id);
                    setIsLoading(false);
                }
            })

            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    useEffect(() => {
        getCategories();

        return () => {
        };
    }, []);

    useEffect(() => {
        getProductDetails();
        if (selectedCategoryId) {
            getProductsList(currentPage);
        }

        return () => {
        };
    }, [currentPage, selectedCategoryId, selectedProdId]);

    const addProduct = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let formData = new FormData();
        formData.append("CategoryId", addProductData?.CategoryId);
        formData.append("Name", addProductData?.Name);
        formData.append("Currency", addProductData?.Currency);
        formData.append("Price", addProductData?.Price);
        formData.append("Description", addProductData?.Description);
        formData.append("Ingredients", addProductData?.Ingredients);
        formData.append("Details", productDetails);
        formData.append("RecommendedProductIds", addProductData?.recommendedProductIds);
        if (selectedProdId) {
            formData.append("Id", selectedProdId);
        }

        addProductData.Images.map((img) => {
            formData.append("Images", img);
        });
        addProductData.Brand_img.map((img) => {
            formData.append("Brand_img", img);
        });
        addProductData.Supp_img.map((img) => {
            formData.append("Supp_img", img);
        });
        multipartPostCallWithErrorResponse(selectedProdId ? ApiConfig.EDIT_PRODUCT : ApiConfig.ADD_PRODUCT, formData)
            .then((res) => {
                setIsLoading(false);
                // if (res.success) {
                //   swal({
                //     text: res.message,
                //     icon: "success",
                //     timer: 2000,
                //     dangerMode: false,
                //   });
                handleClose();
                getProductsList();
                // }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };

    const removeImage = (index) => {
        let images = addProductData.Images;
        images = images.filter((img) => images.indexOf(img) != index);
        setAddProductData({...addProductData, Images: images});
    };

    const onRequirementValueChange = (e, eachRequirement) => {
        let choiceArry = [];
        let changeRequirement = addDetails.map((each) => {
            if (eachRequirement.id === each.id) {
                return {
                    id: each.id, inputValue: e.target.value,
                };
            } else {
                return {
                    ...each,
                };
            }
        });
        setaddDetails(changeRequirement);
        changeRequirement.map((value) => {
            choiceArry.push(value.inputValue);
        });
        const filteredArray = choiceArry.filter((element) => element !== "");
        setProductDetails(JSON.stringify(filteredArray));
    };

    const onRequirementAdd = () => {
        let choiceArry = [];
        let temp = {
            id: addDetails.length > 0 ? addDetails[addDetails.length - 1].id + 1 : 1, inputValue: "",
        };

        let addRequirements = [...addDetails, temp];
        setaddDetails(addRequirements);
        addRequirements.map((value) => {
            choiceArry.push(value.inputValue);
        });
        const filteredArray = choiceArry.filter((element) => element !== "");
        setProductDetails(JSON.stringify(filteredArray));
    };

    const onRemoveRequirement = (id) => {
        let tempRequirements = [];
        addDetails.map((eachRequirement) => {
            if (eachRequirement.id !== id) tempRequirements.push(eachRequirement);
            return true;
        });
        setaddDetails(tempRequirements);
    };

    // DELETE_ADMIN_DATA
    const deleteProduct = () => {
        DeleteCallWithErrorResponse(`${ApiConfig.DELETE_PRODUCT}?id=${selectedProdId}`)
            .then((res) => {
                console.log("Data", res);
                if (res) {
                    swal(res.json.message);
                    handleDeleteClose();
                    getProductsList();
                } else {
                    console.log("error response", res);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const deleteProductImage = (selectedProdImgId, index) => {
        let images = addProductData.Images;
        images = images.filter((img) => images.indexOf(img) != index);
        setAddProductData({...addProductData, Images: images});
        DeleteCallWithErrorResponse(`${ApiConfig.DELETE_PRODUCT_IMG}/${selectedProdImgId}`)
            .then((res) => {
                console.log("Data", res);
                if (res) {
                    swal(res.json.message);
                    getProductsList();
                } else {
                    console.log("error response", res);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleRemoveSuppImg = () => {
        setAddProductData({
          ...addProductData,
          Supp_img: []
        });
        DeleteCallWithErrorResponse(`${ApiConfig.DELETE_PRODUCT_SUPP_IMG}/${selectedProdId}`)
            .then((res) => {
                console.log("Data", res);
                if (res) {
                    swal(res.json.message);
                    getProductsList();
                } else {
                    console.log("error response", res);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (<main
        id="cx-main"
        className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
        <div className="heading-btn-main">
            <div className="heading-common">
                <label htmlFor="">PRODUCTS</label>
            </div>
            <div className="add-btn">
                <button onClick={handleShow}>
                    Add Product
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                    >
                        <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z"/>
                    </svg>
                </button>
            </div>
        </div>

        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {!selectedProdId ? "ADD" : "UPDATE"} PRODUCT
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <div className="row">
                        { !!selectedProdId  && (
                            <div className="col-md-12 mb-3">
                                <Form.Label>ID: {addProductData.id}</Form.Label>
                            </div>
                        ) }

                        <div className="col-md-6 mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                value={addProductData?.Name}
                                onChange={(e) => {
                                    setAddProductData({
                                        ...addProductData, Name: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Your First Name.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label>Category</Form.Label>
                            <Form.Select
                                aria-label="Default select example"
                                required
                                value={addProductData?.CategoryId}
                                onChange={(e) => {
                                    setAddProductData({
                                        ...addProductData, CategoryId: e.target.value,
                                    });
                                }}
                            >
                                <option>Select Category Id</option>
                                {categories?.map((category, index) => {
                                    return (<option key={"category" + index} value={category?.id}>
                                        {category?.name}
                                    </option>);
                                })}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Please Enter Your Last Name.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label>Currency</Form.Label>
                            <Form.Select
                                aria-label="Default select example"
                                required
                                value={addProductData?.Currency}
                                onChange={(e) => {
                                    setAddProductData({
                                        ...addProductData, Currency: e.target.value,
                                    });
                                }}
                            >
                                <option value="">Select Currency</option>
                                <option value="$">$</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Please Select Currency.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label>Price</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                value={addProductData?.Price}
                                onChange={(e) => {
                                    const re = /^[0-9\b.]+$/;

                                    if (e.target.value === "" || re.test(e.target.value)) {
                                        setAddProductData({
                                            ...addProductData, Price: e.target.value,
                                        });
                                    }
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Price.
                            </Form.Control.Feedback>
                        </div>

                        <div className="col-12 mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                value={addProductData?.Description}
                                rows={3}
                                required
                                onChange={(e) => {
                                    setAddProductData({
                                        ...addProductData, Description: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Description.
                            </Form.Control.Feedback>
                        </div>

                        <div className="col-md-6 mb-3">
                            <Form.Label>Recommended products</Form.Label>
                            <Form.Control
                                type="text"
                                value={addProductData?.recommendedProductIds}
                                onChange={(e) => {
                                    setAddProductData({
                                        ...addProductData, recommendedProductIds: e.target.value,
                                    });
                                }}
                            />
                        </div>

                        <DragAndDropSingleFile
                            setFile={(file) => {
                                setAddProductData({
                                    ...addProductData, Brand_img: [file],
                                });
                            }}
                            inputId="brandImg"
                            inputName="brand_img"
                            name="Logo image"
                        />
                        <div className="uploaded_items d-flex mt-2 mb-2">
                            {addProductData.Brand_img.map((img, index) => {
                                return (<div className="item_list" key={"brandImg" + index}>
                                    <img
                                        width={72}
                                        height="72"
                                        className="product_img"
                                        src={img.name ? URL.createObjectURL(img) : img.img}
                                        alt=""
                                    />
                                </div>);
                            })}
                        </div>

                        <DragAndDropSingleFile
                            setFile={(file) => {
                                setAddProductData({
                                    ...addProductData, Supp_img: [file], // Only keep the latest uploaded file
                                });
                            }}
                            inputId="suppImg"
                            inputName="supp_img"
                            name="Supplement Fact"
                        />
                        <div className="uploaded_items d-flex mt-2 mb-2">
                            {addProductData.Supp_img.map((img, index) => {
                                return (
                                  <div className="item_list" key={"suppImg" + index}>
                                    <img
                                        width={72}
                                        height="72"
                                        className="product_img"
                                        src={img.name ? URL.createObjectURL(img) : img.img}
                                        alt=""
                                    />
                                    <a href="#" className="close_item">
                                      <img
                                        src={ic_cross}
                                        alt=""
                                        onClick={handleRemoveSuppImg}
                                      />
                                    </a>
                                  </div>
                                );
                            })}
                        </div>

                        <div className="col-12 mb-3">
                            <Form.Label>Ingredients</Form.Label>
                            <Form.Control
                                as="textarea"
                                value={addProductData?.Ingredients}
                                rows={3}
                                required
                                onChange={(e) => {
                                    setAddProductData({
                                        ...addProductData, Ingredients: e.target.value,
                                    });
                                }}
                            />
                        </div>

                        {addDetails?.map((elementInArray, index) => {
                            return (<div
                                className="col-md-12 mb-3 cx-p-r details-input"
                                key={"elementInArray" + index}
                            >
                                <Form.Label>Details</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={elementInArray.inputValue}
                                    onChange={(e) => {
                                        onRequirementValueChange(e, elementInArray);
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please Enter Details.
                                </Form.Control.Feedback>

                                <div className="remove buttons-modal">
                                    <Link
                                        to="#"
                                        onClick={() => onRemoveRequirement(elementInArray.id)}
                                    >
                                        <img src={ic_cross} alt=""/>
                                    </Link>
                                </div>
                            </div>);
                        })}

                        <div className="add-details buttons-modal">
                            <Link to="#" onClick={onRequirementAdd}>
                                Add Another Details
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="0 0 24 24"
                                >
                                    <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z"/>
                                </svg>
                            </Link>
                        </div>
                    </div>

                    <DragAndDropImages
                        setFile={(files) => {
                            setAddProductData({
                                ...addProductData, Images: [...addProductData.Images, ...files],
                            });
                        }}
                    />
                    <div className="uploaded_items d-flex mt-4">
                        {addProductData.Images.map((img, index) => {
                            console.log("U_img", img);
                            return (<div className="item_list" key={"vehicleImages" + index}>
                                <img
                                    width={72}
                                    height="72"
                                    className="product_img"
                                    src={img.name ? URL.createObjectURL(img) : img.img}
                                    alt=""
                                />
                                <a href="#" className="close_item">
                                    <img
                                        src={ic_cross}
                                        alt=""
                                        onClick={() => deleteProductImage(img.id, index)}
                                    />
                                </a>
                            </div>);
                        })}
                    </div>

                    <div className="buttons-modal border-top pt-3 text-end ">
                        <button className="me-2" type="submit">
                            {isLoading ? (<div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>) : ("Save")}
                        </button>
                        <Link to="#" className="" onClick={handleClose}>
                            Cancel
                        </Link>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal
            show={viewShow}
            onHide={handleViewClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>PRODUCT DETAILS</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Name:</label>
                    </div>
                    <div className="col-md-9 ">
                        <span>{viewData.name}</span>
                    </div>
                </div>

                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Category :</label>
                    </div>
                    <div className="col-md-9 ">
                        <span>{viewData.categoryName}</span>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Price :</label>
                    </div>
                    <div className="col-md-9 ">
                        <span>$ {viewData.price}</span>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Description :</label>
                    </div>
                    <div className="col-md-9 ">
                        <p>{viewData.discription}</p>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Detail(s) :</label>
                    </div>
                    <div className="col-md-9 ">
                        <p>{viewData.details}</p>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Image(s) :</label>
                    </div>
                    <div className="col-md-9 ">
                        <div className="p-details-img">
                            {viewData?.images?.length > 0 ? (viewData.images.map((img) => {
                                return <img src={img?.img} alt=""/>;
                            })) : (<p className="text-warning">No Images Found</p>)}
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

        <Modal
            show={deleteShow}
            onHide={handleDeleteClose}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="delete-msg text-center">
                    <label htmlFor="">Are you sure you want to delete?</label>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <div className="buttons-modal    ">
                    <button
                        className="me-2 "
                        type="submit"
                        style={{backgroundColor: "red"}}
                        onClick={deleteProduct}
                    >
                        Delete
                    </button>
                    <Link to="#" className="" onClick={handleDeleteClose}>
                        Cancel
                    </Link>
                </div>
            </Modal.Footer>
        </Modal>

        <div className="table-wrapper">
            <div class="row g-3 mb-4">
                {/* <div class="col-lg-3">
            <Form.Label>Select Page</Form.Label>

            <Form.Select
              // disabled
              onChange={(e) => {
                setSelectedPage(e.target.value);
              }}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
            </Form.Select>
          </div> */}
                <div class="col-lg-3">
                    <Form.Label>Select Category Id</Form.Label>

                    <Form.Select
                        onChange={(e) => {
                            setSelectedCategoryId(e.target.value);
                        }}
                    >
                        {categories?.map((category, index) => {
                            return (<option key={"category" + index} value={category.id}>
                                {category.name}
                            </option>);
                        })}
                    </Form.Select>
                </div>
            </div>
            <div className="headerFlex">
                <div className="innerLabel">
                    <label className="labelTxt">
                        Total Records : {productsList.length}
                    </label>
                </div>
                <div className="searchFilter">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search By Name ..."
                        value={searchInput}
                        onChange={handleSearchInputChange}
                    />
                </div>
            </div>
            {isLoading ? (<Loading/>) : (<Table striped hover class="table display">
                <thead>
                <tr>
                    <th>Sr No.</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Price</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {productsList?.length > 0 && productsList
                    .filter((item) => {
                        return item?.product?.product_name
                            .toLowerCase()
                            .includes(searchInput.toLowerCase());
                    })
                    .map((product, index) => {
                        return (<tr key={"product" + index}>
                            <td>{index + 1}</td>
                            <td>{product?.product?.product_name}</td>
                            <td>{product?.product?.category}</td>
                            <td>
                                {product?.product?.currency} {product?.product?.price}
                            </td>
                            <td className="action">
                                <Link
                                    className="icon"
                                    to={'/Products/' + product?.product?.product_id + '/Reviews'}
                                >
                                    <img src={ic_product} alt={'show product reviews]'}/>
                                </Link>
                                <Link
                                    to="#"
                                    className="icon"
                                    onClick={() => handleEditShow(product?.product?.product_id)}
                                >
                                    <img src={ic_edit} alt=""/>
                                </Link>
                                <Link
                                    to="#"
                                    className="icon"
                                    onClick={() => {
                                        handleViewShow(product?.product?.product_id);
                                    }}
                                >
                                    <img src={ic_eyes} alt=""/>
                                </Link>
                                <Link
                                    to="#"
                                    className="icon"
                                    onClick={() => {
                                        handleDeleteShow(product?.product?.product_id);
                                    }}
                                >
                                    <img src={ic_delete} alt=""/>
                                </Link>
                            </td>
                        </tr>);
                    })}
                </tbody>
            </Table>)}
            <div className="d-flex justify-content-end">
                {productsList && productsList.length > 0 ? (<PaginationCustomer
                    changePage={changePage}
                    pageCount={numPages}
                    currentPage={currentPage}
                />) : (<div>
                    <h5 style={{color: "red"}}> Records Not Found</h5>
                </div>)}
            </div>
        </div>
    </main>);
};

export default Products;
